import type { InterceptorFactory } from "./types";

export const headerInterceptor: InterceptorFactory = {
  request: () => ({
    onFulfilled: (config) => config,
    onRejected: (error) => Promise.reject(error),
  }),
};
